'use client';
import { BaseModal } from '../../../../../ui/src/components/Modals/BaseModal/BaseModal';
import { BasePrimaryButton } from '../../../../../ui/src/components/Buttons/BasePrimaryButton/BasePrimaryButton';
import styles from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
	isOpen: boolean;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	onConfirm: () => void;
	onCancel: () => void;
	isLoading?: boolean;
}

export const ConfirmationModal = ({
	isOpen,
	title,
	message,
	confirmText = 'Confirmar',
	cancelText = 'Cancelar',
	onConfirm,
	onCancel,
	isLoading,
}: ConfirmationModalProps) => {
	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onCancel}
			title={title}
			isLoading={isLoading}
			actions={
				<>
					<button className={styles.cancelButton} onClick={onCancel} disabled={isLoading}>
						{cancelText}
					</button>
					<BasePrimaryButton
						onClick={onConfirm}
						disabled={isLoading}
						className={styles.confirmButton}
					>
						{confirmText}
					</BasePrimaryButton>
				</>
			}
		>
			<p className={styles.message}>{message}</p>
		</BaseModal>
	);
};
